import { HttpClientModule } from '@angular/common/http';
import { Component, effect } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { LanguageService } from '../../../../core/services/language.service';
import { QuoteService } from '../../services/quote.service';
import { QuoteStateService } from '../../services/quote-state.service';

@Component({
  selector: 'app-quote-form',
  imports: [ReactiveFormsModule, HttpClientModule, TranslateModule],
  templateUrl: './quote-form.component.html',
  styleUrl: './quote-form.component.scss',
})
export class QuoteFormComponent {
  private lastRouteLine = '';

  readonly form = new FormGroup({
    fullName: new FormControl('', { nonNullable: true }),
    email: new FormControl('', { nonNullable: true }),
    phone: new FormControl('', { nonNullable: true }),
    company: new FormControl('', { nonNullable: true }),
    cargoType: new FormControl('', { nonNullable: true }),
    weight: new FormControl('', { nonNullable: true }),
    details: new FormControl('', { nonNullable: true }),
  });

  constructor(
    private readonly quoteState: QuoteStateService,
    private readonly quoteService: QuoteService,
    private readonly languageService: LanguageService,
    private readonly translateService: TranslateService
  ) {
    effect(() => {
      const origin = this.quoteState.origin();
      const destination = this.quoteState.destination();
      this.languageService.currentLang();
      this.updateDetailsWithRoute(origin, destination);
    });
  }

  submit(): void {
    if (this.form.invalid) {
      return;
    }
    this.quoteService.create(this.form.getRawValue()).subscribe();
  }

  private updateDetailsWithRoute(origin: string, destination: string): void {
    const originLabel = this.translateService.instant('quote_form.route.origin_label');
    const destinationLabel = this.translateService.instant('quote_form.route.destination_label');
    const notAvailable = this.translateService.instant('quote_form.route.not_available');
    const originValue = origin ? this.translateService.instant(origin) : notAvailable;
    const destinationValue = destination ? this.translateService.instant(destination) : notAvailable;
    const routeLine =
      origin || destination ? `${originLabel}: ${originValue}, ${destinationLabel}: ${destinationValue}` : '';
    const control = this.form.controls.details;
    const current = control.value ?? '';
    const cleaned = this.lastRouteLine ? current.replace(this.lastRouteLine, '').trim() : current.trim();

    if (!routeLine) {
      this.lastRouteLine = '';
      if (cleaned !== current) {
        control.setValue(cleaned, { emitEvent: false });
      }
      return;
    }

    const next = cleaned ? `${cleaned}\n${routeLine}` : routeLine;
    this.lastRouteLine = routeLine;
    if (next !== current) {
      control.setValue(next, { emitEvent: false });
    }
  }
}
